import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Box, Typography, Button, Container, Paper } from '@mui/material';
import { Explore as ExploreIcon, Home as HomeIcon } from '@mui/icons-material';

const NotFoundPage = () => {
  return (
    <Container maxWidth="md" sx={{ mt: 8 }}>
      <Paper elevation={3} sx={{ p: 4, textAlign: 'center' }}>
        <Box
          component="svg"
          viewBox="0 0 100 100"
          sx={{
            width: 120,
            height: 120,
            opacity: 0.7,
            mb: 3
          }}
        >
          <circle cx="50" cy="50" r="45" fill="#D4AF37" stroke="#0A3161" strokeWidth="2"/>
          <line x1="50" y1="10" x2="50" y2="90" stroke="#0A3161" strokeWidth="3"/>
          <line x1="10" y1="50" x2="90" y2="50" stroke="#0A3161" strokeWidth="3"/>
          <line x1="22" y1="22" x2="78" y2="78" stroke="#0A3161" strokeWidth="1.5"/>
          <line x1="22" y1="78" x2="78" y2="22" stroke="#0A3161" strokeWidth="1.5"/>
          <line x1="35" y1="35" x2="65" y2="65" stroke="#A52A2A" strokeWidth="6" strokeLinecap="round"/>
          <line x1="35" y1="65" x2="65" y2="35" stroke="#A52A2A" strokeWidth="6" strokeLinecap="round"/>
        </Box>

        <Typography variant="h4" gutterBottom>
          404 - Page Not Found
        </Typography>

        <Typography variant="body1" paragraph>
          Looks like you've ventured off the map. This page doesn't exist or has been moved.
        </Typography>

        <Typography variant="body1" paragraph sx={{ fontStyle: 'italic', color: 'text.secondary' }}>
          "Not all those who wander are lost, but this page definitely is."
        </Typography>

        <Box sx={{ mt: 4, display: 'flex', justifyContent: 'center', gap: 2 }}>
          <Button
            variant="contained"
            color="primary"
            startIcon={<HomeIcon />}
            component={RouterLink}
            to="/"
            size="large"
          >
            Back to Home
          </Button>

          <Button
            variant="outlined"
            color="secondary"
            startIcon={<ExploreIcon />}
            component={RouterLink}
            to="/explore"
            size="large"
          >
            Explore Content
          </Button>
        </Box>
      </Paper>
    </Container>
  );
};

export default NotFoundPage;